// extracted by mini-css-extract-plugin
module.exports = {"grid":"card-grid-module--grid--3AZNI"};